// extracted by mini-css-extract-plugin
export default {"wrapper":"H4-z","play":"I4-z"};